/*------------ Sliders ----------------*/

var swiperContainer = document.querySelector(".mySwiper");
    var dataAutoplay = parseInt(swiperContainer.getAttribute("data-autoplay"));


var swiper = new Swiper(".mySwiper", {
    spaceBetween: 0,
    effect: "fade",
    autoplay: {
        delay: dataAutoplay,
        disableOnInteraction: false,
    },
    speed: 100
});

var swiper = new Swiper(".prodThumbsSl", {
    spaceBetween: 10,
    slidesPerView: 5,
    freeMode: true,
    watchSlidesProgress: true,
    grabCursor: true,
    direction: 'horizontal',
    navigation: {
        nextEl: "#prodNext"
    },
    breakpoints: {
        768: {
            direction: 'vertical',
        }
    },
});
var swiper2 = new Swiper(".prodMainSl", {
    spaceBetween: 0,
    thumbs: {
        swiper: swiper,
    },
});

AOS.init();

 $(document).ready(function() {
                $('.product-form__input input[type=radio]+label').click(function() {
                    var inputValue = $(this).attr("data-value");
                    var targetBox = $(this).attr("data-id");
                    $(targetBox).html(inputValue);
                });
            });